import { useSirenEntity } from '~/utility/BinSentry-ui-utility';

export default function useBinLevelBinProperties({ binId }) {
  const { entity: bin, loading: binLoading } = useSirenEntity({ href: binId });

  const binLevelPropertiesHref = bin?.getLinkByRel('https://api.binsentry.com/rel/bin-level-bin-properties')?.href;
  const { entity: binLevelProperties, loading: binLevelPropertiesLoading } = useSirenEntity({ href: binLevelPropertiesHref });

  const loading = binLoading || binLevelPropertiesLoading;

  return {
    binLevelProperties,
    loading,
  };
}
